import {Opaque} from 'type-fest';
import {getUniqueId} from 'react-native-device-info';

export const UNIQUE_ID = Symbol();
export type UniqueId = Opaque<string, typeof UNIQUE_ID>;

export default () => getUniqueId() as Promise<UniqueId>;
